import PageHeader from 'antd/lib/page-header'

import 'antd/lib/page-header/style'

export * from 'antd/lib/page-header'

export default PageHeader
